// extracted by mini-css-extract-plugin
module.exports = {"root":"LineClampV2_root__kvLTL","expanded":"LineClampV2_expanded__ckaRY","mobileOnly":"LineClampV2_mobileOnly__wtZOb","button":"LineClampV2_button__0JFzO"};